import { useQuery } from "@tanstack/react-query";
import { AssessmentsClient } from "@lib/ShiOneClient";
import { ApiClientConfig } from "../../../../../auth/ApiClientConfig";
import { CACHE_KEY_ASSESSMENTS } from "@features/assessments-feature/constants";
import { ShiOnePermission } from "../../../../../auth/authorizationTypes";

const api = new AssessmentsClient(
  ApiClientConfig,
  import.meta.env.API_ENDPOINT,
);

const useAssessmentPermissions = () => {
  const queryFn = async (): Promise<Record<string, ShiOnePermission>> => {
    try {
      const metadata = await api.getAssessmentPermissions();
      return (metadata?.programPermissions ?? {}) as Record<string, ShiOnePermission>;
    } catch (error) {
      console.error("Failed to fetch assessment permissions", error);
      return {};
    }
  };

  return useQuery<Record<string, ShiOnePermission>, Error>({
    queryKey: [`${CACHE_KEY_ASSESSMENTS}-permissions`],
    queryFn,
    staleTime: Infinity, // Permissions static per deployment
  });
};

export default useAssessmentPermissions;
